export const getMatchedPlaces = (placeOfBirthRaw, options) => {
  if (!placeOfBirthRaw || !Array.isArray(options) || !options.length)
    return null;

  const placeOfBirth = placeOfBirthRaw.toLowerCase();

  const matched = options
    .filter(item => item.value && item.label)
    .filter(item => {
      const label = item.label.toLowerCase();
      return (
        label === placeOfBirth ||
        label.includes(placeOfBirth) ||
        placeOfBirth.includes(label)
      );
    })
    .sort((a, b) => {
      const aLabel = a.label.toLowerCase();
      const bLabel = b.label.toLowerCase();

      if (aLabel === placeOfBirth) return -1;
      if (bLabel === placeOfBirth) return 1;

      return aLabel.length - bLabel.length;
    });

  return matched[0] || null;
};
